import { ColumnDef, Row, Table } from '@tanstack/react-table';
import { useMemo } from 'react';
import { Checkbox } from '../../Checkbox';
import { useTableContext } from '../TableContext';

const renderHeaderCheckbox = <T,>({ table }: { table: Table<T> }) => (
    <Checkbox
        {...{
            checked: table.getIsAllRowsSelected(),
            indeterminate: table.getIsSomeRowsSelected(),
            onChange: table.getToggleAllRowsSelectedHandler(),
        }}
    />
);

const renderCellCheckbox = <T,>({ row }: { row: Row<T> }) => (
    <Checkbox
        {...{
            checked: row.getIsSelected(),
            disabled: !row.getCanSelect(),
            indeterminate: row.getIsSomeSelected(),
            onChange: row.getToggleSelectedHandler(),
        }}
    />
);

const selectionColumn = {
    id: 'select',
    header: renderHeaderCheckbox,
    cell: renderCellCheckbox,
    enableColumnFilter: false,
    enableSorting: false,
};

export const useTableColumns = <T,>({ enableRowSelection }: { enableRowSelection: boolean }): ColumnDef<T>[] => {
    const { columns } = useTableContext<T>();
    return useMemo(() => (enableRowSelection ? [selectionColumn, ...columns] : columns), [columns, enableRowSelection]);
};
